import {Component, inject, Input} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MessageService} from 'primeng/api';
import {Editor} from 'primeng/editor';
import {Tooltip} from 'primeng/tooltip';
import Quill from 'quill';
import {StringUtils} from '@shared/utils/string.utils';

@Component({
  selector: 'app-custom-editor',
  imports: [
    Editor,
    ReactiveFormsModule,
    Tooltip
  ],
  templateUrl: './custom-editor.component.html',
  standalone: true,
  styleUrl: './custom-editor.component.css'
})
export class CustomEditorComponent {
  @Input() control!: FormControl;
  @Input() disabled = false;
  @Input() inputId?: string;
  @Input() labelledBy?: string;
  quillEditorInstance!: Quill;
  maxLength = 3000;
  messageService = inject(MessageService);

  onEditorInit(event: any) {
    this.quillEditorInstance = event.editor;
    if (this.labelledBy) {
      this.quillEditorInstance.root.setAttribute('aria-labelledby', this.labelledBy);
    }

    if (this.disabled || this.control?.disabled) {
      this.quillEditorInstance.enable(false);
    }

    this.quillEditorInstance.on('text-change', (delta, oldDelta, source) => {
      if (source === 'user') {
        const text = this.quillEditorInstance.getText();
        const currentLength = text.length > 0 ? text.length - 1 : 0;

        // Limite de caracteres
        if (currentLength > this.maxLength) {
          const excessLength = currentLength - this.maxLength;
          this.quillEditorInstance.deleteText(this.maxLength, excessLength);
          this.messageService.add({
            severity: 'warn',
            summary: 'Limite de Caracteres',
            detail: `A descrição atingiu o limite máximo de ${this.maxLength} caracteres.`,
            life: 3000
          });
        }

        // Bloqueia imagens coladas
        const opsWithImages = delta.ops?.filter(op => {
          return typeof op.insert === 'object' && op.insert !== null && 'image' in op.insert;
        });

        if (opsWithImages?.length) {
          this.quillEditorInstance.setText('');
          this.control.setValue(null);
          this.messageService.add({
            severity: 'warn',
            summary: 'Imagem não permitida',
            detail: 'Não é permitido inserir imagens.',
            life: 3000
          });
          return;
        }

        const html = this.quillEditorInstance.root.innerHTML;
        if (StringUtils.isHtmlEmpty(html)) {
          this.control.setValue('');
          this.control.updateValueAndValidity();
        }
      }
    });

    // --- Ajusta texto inicial se já ultrapassar limite ---
    const initialText = this.quillEditorInstance.getText();
    const excessInitial = initialText.length - 1 - this.maxLength;
    if (excessInitial > 0) {
      this.quillEditorInstance.deleteText(this.maxLength, excessInitial);
    }
  }

}
